import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customer-experience-request-access',
  templateUrl: './customer-experience-request-access.component.html',
  styleUrls: ['./customer-experience-request-access.component.scss']
})
export class CustomerExperienceRequestAccessComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
